import Api from 'services/apiService.js';

import {
  SEARCH_TAGS,
  HIDE_TAGS,
  GET_HIDDEN_TAGS,
  DELETE_HIDDEN_TAG,
} from 'actionTypes';

function deleteHiddenTagEndpoint(endpointArgs) {
  const { id } = endpointArgs;
  return `pse/hidden-tags/${id}`;
}

function searchTagsEndpoint(endpointArgs) {
  const { name } = endpointArgs;
  return `pse/program-tags?name=${name}`;
}

export default {
  [HIDE_TAGS]: {
    endpoint: 'pse/hidden-tags',
    apiFunc: Api.post,
  },
  [GET_HIDDEN_TAGS]: {
    endpoint: 'pse/hidden-tags',
    apiFunc: Api.get,
  },
  [DELETE_HIDDEN_TAG]: {
    endpoint: deleteHiddenTagEndpoint,
    apiFunc: Api.remove,
  },
  [SEARCH_TAGS]: {
    endpoint: searchTagsEndpoint,
    apiFunc: Api.get,
  },
};



// WEBPACK FOOTER //
// ./src/endpoints/tagEndpoints.js